import { getCityList, addCity, delCityByCode } from '@/api/home/city'
import { message } from 'ant-design-vue'
import { useUserStore } from '@/store'

export class CityController {
  static async list () {
    const { data } = await getCityList({ category: useUserStore().userInfo.agent.category })
    return {
      data: data[0].children
    }
  }

  static async add (city: HOME.CITY) {
    const { code } = await addCity({
      ...city,
      category: useUserStore().userInfo.agent.category
    })
    code === 0 ? message.success('新增成功') : message.error('')
    return code
  }

  static async del (_code: string) {
    const { code } = await delCityByCode(_code)
    code === 0 ? message.success('删除成功') : message.error('')
    return code
  }
}
